import { AnyAction } from 'redux';
import { SET_CART_ITEMS_COUNT } from '../types/cart';
import { LOGOUT_SUCCESS } from '../types/auth';

export type CartType = {
    cartItemsCount: number
};

const initState: Partial<CartType> = {
    cartItemsCount: 0
};
export default function cartReducer(state = initState, action: AnyAction): Partial<CartType> {
    switch (action.type) {
        case SET_CART_ITEMS_COUNT: {
            return {
                ...state,
                cartItemsCount: action.cartItemsCount,
            };
        }
        case LOGOUT_SUCCESS: {
            return {
                ...state,
                cartItemsCount: 0
            }
        }
        default:
            return state;
    }
}